import { render } from "./PresupuestosView.vue?vue&type=template&id=874da412&scoped=true"
import script from "./PresupuestosView.vue?vue&type=script&lang=js"
export * from "./PresupuestosView.vue?vue&type=script&lang=js"

import "./PresupuestosView.vue?vue&type=style&index=0&id=874da412&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-874da412"]])

export default __exports__